const PU = process.env.PUBLIC_URL;

const experiences = [
  {
    id: 1,
    company: 'Thoughtworks',
    logoSrc: `${PU}/thoughtworks_logo.jpeg`,
    client: 'Peloton',
    role: 'Senior Mobile Developer - Android',
    period: 'Oct 2025 – Present',
    periodKey: 'experience.jobs.thoughtworks.period',
    tags: ['Android', 'Kotlin', 'Senior', 'Consultancy', 'International', 'Leadership'],
    highlights: [
      'experience.jobs.thoughtworks.h1',
      'experience.jobs.thoughtworks.h2',
      'experience.jobs.thoughtworks.h3',
    ],
  },
  {
    id: 2,
    company: 'Magazine Luiza',
    logoSrc: `${PU}/luizalabs_logo.jpeg`,
    client: null,
    role: 'Senior Mobile Developer - Android',
    period: 'Sep 2024 – Oct 2025',
    periodKey: 'experience.jobs.magalu.period',
    tags: ['Android', 'Kotlin', 'Senior', 'SDK', 'E-commerce'],
    highlights: [
      'experience.jobs.magalu.h1',
      'experience.jobs.magalu.h2',
      'experience.jobs.magalu.h3',
    ],
  },
  {
    id: 3,
    company: 'XP Inc',
    logoSrc: `${PU}/xpinc_logo.jpeg`,
    client: null,
    role: 'Mid / Senior Mobile Developer - Android & Flutter',
    period: 'Oct 2021 – Feb 2024',
    periodKey: 'experience.jobs.xp.period',
    tags: ['Android', 'Flutter', 'Kotlin', 'Senior', 'Fintech', 'Mentoring'],
    highlights: [
      'experience.jobs.xp.h1',
      'experience.jobs.xp.h2',
      'experience.jobs.xp.h3',
    ],
  },
  {
    id: 10,
    company: 'Career Break',
    logoSrc: null,
    client: null,
    subtitle: 'Backpacking South America',
    role: 'Sabbatical',
    period: 'Jan 2017 – Sep 2021',
    periodKey: null,
    sabbatical: true,
    tags: [],
    highlights: [
      'experience.jobs.sabbatical.h1',
      'experience.jobs.sabbatical.h2',
      'experience.jobs.sabbatical.h3',
    ],
  },
  {
    id: 4,
    company: 'NTT Data',
    logoSrc: `${PU}/nttdata_logo.jpeg`,
    client: 'BEES Ambev',
    role: 'Android Developer',
    period: null,
    periodKey: null,
    parallel: true,
    tags: ['Android', 'Consultancy', 'Fintech', 'Logistics'],
    highlights: [
      'experience.jobs.nttdata.h1',
      'experience.jobs.nttdata.h2',
      'experience.jobs.nttdata.h3',
    ],
  },
  {
    id: 5,
    company: 'HubXP',
    logoSrc: `${PU}/hubxp_logo.jpeg`,
    client: 'Afya',
    role: 'Android Developer',
    period: null,
    periodKey: null,
    parallel: true,
    tags: ['Android', 'Consultancy', 'Healthcare', 'Education'],
    highlights: [
      'experience.jobs.hubxp.h1',
      'experience.jobs.hubxp.h2',
      'experience.jobs.hubxp.h3',
    ],
  },
  {
    id: 6,
    company: 'OmniChat',
    logoSrc: `${PU}/omnichat_logo.jpeg`,
    client: null,
    role: 'Mid-Level Android Developer',
    period: 'Jan 2015 – Dec 2016',
    periodKey: 'experience.jobs.omnichat.period',
    tags: ['Android'],
    highlights: [
      'experience.jobs.omnichat.h1',
      'experience.jobs.omnichat.h2',
      'experience.jobs.omnichat.h3',
    ],
  },
  {
    id: 7,
    company: 'SnowmanLabs',
    logoSrc: `${PU}/snowman_labs_logo.jpeg`,
    client: null,
    role: 'Mid-Level Android Developer',
    period: 'Jan 2015 – Dec 2015',
    periodKey: 'experience.jobs.snowmanlabs.period',
    tags: ['Android', 'Consultancy'],
    highlights: [
      'experience.jobs.snowmanlabs.h1',
      'experience.jobs.snowmanlabs.h2',
      'experience.jobs.snowmanlabs.h3',
    ],
  },
  {
    id: 8,
    company: 'TOTVS',
    logoSrc: `${PU}/totvs_logo.jpeg`,
    client: null,
    role: 'Mobile Systems Analyst',
    period: 'Feb 2014 – Jan 2015',
    periodKey: 'experience.jobs.totvs.period',
    tags: ['Android'],
    highlights: [
      'experience.jobs.totvs.h1',
      'experience.jobs.totvs.h2',
      'experience.jobs.totvs.h3',
    ],
  },
  {
    id: 9,
    company: 'Softin',
    logoSrc: `${PU}/softin_logo.jpeg`,
    client: null,
    role: 'Jr Web & Android Developer',
    period: 'May 2012 – Jan 2014',
    periodKey: 'experience.jobs.softin.period',
    tags: ['Android', 'Web'],
    highlights: [
      'experience.jobs.softin.h1',
      'experience.jobs.softin.h2',
      'experience.jobs.softin.h3',
    ],
  },
];

export default experiences;
